import { render, staticRenderFns } from "./CRUDMensagens.vue?vue&type=template&id=346b82f4&scoped=true&"
import script from "./CRUDMensagens.vue?vue&type=script&lang=js&"
export * from "./CRUDMensagens.vue?vue&type=script&lang=js&"
import style0 from "./CRUDMensagens.vue?vue&type=style&index=0&id=346b82f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346b82f4",
  null
  
)

export default component.exports